<!--
  ~ Copyright (c) 2021 Signum+ Software & Facility GmbH
  ~ Author: sebastian.woess@signum-plus.at
  -->

<ng-container *ngIf="labelModel && model.labelPosition === 'left'" [kitComponent]="labelModel"
  kitComponentClass="form-check-label" [kitComponentAttributes]="{ for: id }"></ng-container>

<input [kitCheckboxInput]="model" class="form-check-input" [id]="id">

<ng-container *ngIf="labelModel && model.labelPosition === 'right'" [kitComponent]="labelModel"
  kitComponentClass="form-check-label" [kitComponentAttributes]="{ for: id }"></ng-container>
